import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, DialogActions, FormControl, Grid, InputAdornment, InputLabel, Select, TextField } from '@mui/material';
import MaterialUiPhoneNumber from 'material-ui-phone-number';
import React from 'react';

import { ContextStore } from '../store/contextStore';
import { DELIVERY_METHOD_CHAT, DELIVERY_METHOD_CHAT_DESTINATION, DELIVERY_METHOD_EMAIL, DELIVERY_METHOD_EMAIL_DESTINATION, DELIVERY_METHOD_SMS, DELIVERY_METHOD_SMS_DESTINATION, DELIVERY_METHOD_WHATSAPP, DELIVERY_METHOD_WHATSAPP_DESTINATION, DELIVERY_METHOD_AIRBNB, DELIVERY_METHOD_AIRBNB_DESTINATION, EMAIL_TO_ADDRESS, EMAIL_TO_SUPPORT, SMS_TO_NUMBER, SMS_TO_SUPPORT, WHATSAPP_TO_NUMBER, AIRBNB_TO_ARBITRARY_THREAD_ID, WHATSAPP_TO_SUPPORT } from './utils';
import { genHtmlOptions } from '../utils';
import { CREATE, DataAPIContext } from '../api';


const getFieldPrefix = (m) => {
    switch (m) {
        case DELIVERY_METHOD_EMAIL: return "email";
        case DELIVERY_METHOD_SMS: return "sms";
        case DELIVERY_METHOD_WHATSAPP: return "whatsapp";
        case DELIVERY_METHOD_AIRBNB: return "airbnb";
        case DELIVERY_METHOD_CHAT: return "chat";
        default: return null;
    }
}

const getDestinationOptions = (m, event) => {
    let raw_options = [];
    let disabled = {};
    switch (m) {
        case DELIVERY_METHOD_EMAIL:
            raw_options = DELIVERY_METHOD_EMAIL_DESTINATION;
            if (event.startsWith('tour_departure.')) {
                Object.keys(raw_options).filter(x => +x !== +EMAIL_TO_ADDRESS).forEach(k => disabled[k] = true);
            }
            break;
        case DELIVERY_METHOD_SMS:
            raw_options = DELIVERY_METHOD_SMS_DESTINATION;
            break;
        case DELIVERY_METHOD_WHATSAPP:
            raw_options = DELIVERY_METHOD_WHATSAPP_DESTINATION;
            break;
        case DELIVERY_METHOD_AIRBNB:
            raw_options = DELIVERY_METHOD_AIRBNB_DESTINATION;
            break;
        case DELIVERY_METHOD_CHAT:
            raw_options = DELIVERY_METHOD_CHAT_DESTINATION;
            break;
        default:
            break;
    }
    console.log('settings', event, raw_options, disabled);
    return genHtmlOptions(raw_options, disabled);
}

const getIsSupportDestination = (m, d) => {
    switch (m) {
        case DELIVERY_METHOD_EMAIL:
            return d === EMAIL_TO_SUPPORT;
        case DELIVERY_METHOD_SMS:
            return d === SMS_TO_SUPPORT;
        case DELIVERY_METHOD_WHATSAPP:
            return d === WHATSAPP_TO_SUPPORT;
        default:
            return false;
    }
}

const getIsArbitraryDestination = (m, d) => {
    switch (m) {
        case DELIVERY_METHOD_EMAIL:
            return d === EMAIL_TO_ADDRESS;
        case DELIVERY_METHOD_SMS:
            return d === SMS_TO_NUMBER;
        case DELIVERY_METHOD_WHATSAPP:
            return d === WHATSAPP_TO_NUMBER;
        case DELIVERY_METHOD_AIRBNB:
            return d === AIRBNB_TO_ARBITRARY_THREAD_ID;
        default:
            return false;
    }
}

const getSupportOptions = (contacts) => {
    const dict = {};
    contacts.forEach((c) => {
        dict[c.id] = c.name;
    });
    return genHtmlOptions(dict);
}

const StandardNotificationSettingsDialog = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const { tourOperator } = React.useContext(ContextStore);
    const [nf, setNf] = React.useState(props.data);
    const [phoneServerCheck, setPhoneServerCheck] = React.useState(false);
    const [phoneServerCheckError, setPhoneServerCheckError] = React.useState(false);
    const [, setPhoneBlur] = React.useState(false);

    const prefix = getFieldPrefix(props.data.method);
    const destionationOptions = getDestinationOptions(nf.method, props.event);
    const isSupportDestination = getIsSupportDestination(nf.method, nf[`${prefix}_destination`]);
    const isArbitraryDestination = getIsArbitraryDestination(nf.method, nf[`${prefix}_destination`]);
    console.log('settings', tourOperator.support_contacts);
    const supportOptions = getSupportOptions(tourOperator.support_contacts);

    const onFieldValueChange = (e) => {
        setNf((prev) => ({...prev, [e.target.name]: e.target.value}));
    }

    const onPhoneNumberChange = (field, value) => {
        setNf((prev) => ({...prev, [field]: value}));
    }

    const onIntSelectChange = (e) => {
        setNf((prev) => ({...prev, [e.target.name]: +e.target.value}));
    }

    const onSave = () => {
        props.onChange && props.onChange(nf);
        props.onClose && props.onClose();
    }

    const validatePhoneNumber = (phone) => {
        setPhoneServerCheck(true);
        return dataAPI(CREATE, 'user/validate_phone', { data: { phone: phone } })
            .then((res) => {
                setPhoneServerCheckError(!res.data || !res.data.status);
            })
            .finally(() => {
                setPhoneServerCheck(false);
            });
    }

    const onPhoneBlur = (ev) => {
        // testIfAreaCode(ev.target.value);
        validatePhoneNumber(ev.target.value);
        setPhoneBlur(true);
    };


    if (!prefix) {
        return (<Dialog onClose={props.onClose} open={!!props.open}>This delivery method has no settings</Dialog>);
    }

    return (<Dialog onClose={props.onClose} open={!!props.open} maxWidth="md" fullWidth>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
            <Grid container direction="row" spacing={2}>
                { props.data.method === DELIVERY_METHOD_EMAIL && (<>
                    <Grid item xs={12}>
                        <TextField
                            disabled={props.readOnly}
                            name={`${prefix}_subject`}
                            value={nf[`${prefix}_subject`]}
                            label="Email subject"
                            variant="filled"
                            size="small"
                            fullWidth
                            onChange={onFieldValueChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled={props.readOnly}
                            name={`${prefix}_replyto`}
                            value={props.data[`${prefix}_replyto`]}
                            label="Email reply to:"
                            defaultValue={nf[`${prefix}_replyto`]}
                            variant="filled"
                            fullWidth
                            onChange={onFieldValueChange}
                        />
                    </Grid>
                </>)}
                <Grid item xs={12}>
                    <FormControl fullWidth disabled={props.readOnly}>
                        <InputLabel style={{ marginTop: '1rem' }} id="destination">
                            Destination
                        </InputLabel>
                        <Select
                            onChange={onIntSelectChange}
                            labelId={`${prefix}_destination`}
                            name={`${prefix}_destination`}
                            size="small"
                            variant="filled"
                            native
                            defaultValue={nf[`${prefix}_destination`]}>
                            {destionationOptions}
                        </Select>
                    </FormControl>                    
                </Grid>
                {isSupportDestination && (<>
                    <Grid item xs={12}>
                        <FormControl fullWidth disabled={props.readOnly}>
                            <InputLabel style={{ marginTop: '1rem' }} id="support_contact">
                                Support contact
                            </InputLabel>
                            <Select
                                onChange={onIntSelectChange}
                                labelId={`${prefix}_support`}
                                name={`${prefix}_support`}
                                size="small"
                                variant="filled"
                                native
                                defaultValue={nf[`${prefix}_support`]}>
                                {supportOptions}
                            </Select>
                        </FormControl>
                    </Grid>
                </>)}
                {isArbitraryDestination && (nf.method === DELIVERY_METHOD_EMAIL) && (<>
                    <Grid item xs={12}>
                        <TextField
                            disabled={props.readOnly}
                            name="email_address"
                            value={nf.email_address}
                            label="Email address"
                            variant="filled"
                            size="small"
                            fullWidth
                            onChange={onFieldValueChange}
                        />
                    </Grid>
                </>)}
                {isArbitraryDestination && ([DELIVERY_METHOD_SMS, DELIVERY_METHOD_WHATSAPP, DELIVERY_METHOD_AIRBNB].indexOf(nf.method) >= 0) && (<>
                    <Grid item xs={12}>
                        <MaterialUiPhoneNumber
                            disabled={props.readOnly}
                            variant="filled"
                            size="small"
                            name={`${prefix}_number`}
                            label="Arbitrary Phone Number"
                            fullWidth
                            autoComplete="off"
                            defaultCountry="us"
                            inputProps={{
                                name: 'phone',
                            }}
                            onChange={(number) => onPhoneNumberChange(`${prefix}_number`, number)}
                            onBlur={onPhoneBlur}
                            // CP-6601: the phone input reads only `value`; a `defaultValue` left the saved number blank.
                            value={nf[`${prefix}_number`] || ''}
                            InputProps={{
                                endAdornment: phoneServerCheck && (
                                    <InputAdornment position="end">
                                        <CircularProgress size={20} color="primary" />
                                    </InputAdornment>
                                ),
                            }}
                            helperText={phoneServerCheckError && 'Please enter a valid phone number'}
                            error={phoneServerCheckError}
                        />
                    </Grid>
                </>)}
                {/* <Grid item xs={12}>
                    <pre>{JSON.stringify(nf, null, 4)}</pre>
                </Grid> */}
            </Grid>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
                <Button color="primary" variant="contained" onClick={onSave}>Apply & close</Button>
            </DialogActions>
        </DialogContent>
    </Dialog>);    
}

export default StandardNotificationSettingsDialog;
